<template>
    <nav class="ml-7 hidden items-center space-x-7 lg:flex xl:space-x-7">
        <HeaderDropdown
            label="Доставка"
            dropdown-class="rounded-20 -left-4 top-[calc(100%_+_2rem)] xl:top-[calc(100%_+_2.3rem)] rounded-tl-none"
            chevron-right
            :is-open="openMenu === 'delivery'"
            class="relative"
            @close="closeMenu"
            @open="openProductMenuHandler">
            <HeaderLinkList
                :items="deliveryList"
                @close="closeMenuImmediately" />
        </HeaderDropdown>

        <HeaderNavItem to="/portfolio"> Опыт</HeaderNavItem>

        <HeaderDropdown
            label="Про Cromi"
            dropdown-class="-left-4 top-[calc(100%_+_2rem)] xl:top-[calc(100%_+_2.3rem)] rounded-20 rounded-tl-none"
            chevron-right
            :is-open="openMenu === 'proCromi'"
            class="relative"
            @close="closeMenu"
            @open="openProCromiMenuHandler">
            <!-- class="absolute -left-4 top-[3.5rem] overflow-hidden rounded-20 rounded-tl-none bg-white opacity-0 transition-all duration-300"> -->

            <HeaderLinkList
                :items="proCromiList"
                @close="closeMenuImmediately" />
        </HeaderDropdown>
        <HeaderNavItem to="/contacts"> Контакты</HeaderNavItem>
    </nav>
</template>
<script lang="ts" setup>
import HeaderDropdown from '~/components/layouts/header/HeaderDropdown.vue'
import HeaderLinkList from '~/components/layouts/header/HeaderLinkList.vue'
import HeaderNavItem from '~/components/layouts/header/HeaderNavItem.vue'
import type { IHeaderLinkItem } from '~/components/layouts/header/header.types'

const proCromiList: IHeaderLinkItem[] = [
    {
        title: 'О компании',
        icon: 'logo',
        link: '/about',
    },
    {
        title: 'Отзывы',
        icon: 'star',
        link: '/reviews',
    },
    {
        title: 'Оплата',
        icon: 'car',
        link: '/pay',
    },
    {
        title: 'Вопрос-ответ',
        icon: 'question',
        link: '/faq',
    },
    {
        title: 'Видео',
        icon: 'video',
        link: '/videos',
    },
    {
        title: 'Блог PRO',
        icon: 'note',
        link: '/pro',
    },
]
const deliveryList: IHeaderLinkItem[] = [
    {
        title: 'По Москве и СПб',
        icon: 'delivery-msk-spb',
        link: '/delivery-msk-and-spb',
    },
    {
        title: 'В другие города',
        icon: 'russia-map',
        link: '/delivery-russia',
    },
]
type Timeout = ReturnType<typeof setTimeout>

const openTimer = ref<null | Timeout>(null)
const closeTimer = ref<null | Timeout>(null)
const OPEN_TIMEOUT = 150
const CLOSE_TIMEOUT = 150
const closeMenuTimeout = ref<null | Timeout>(null)
const openMenu: Ref<null | 'delivery' | 'proCromi'> = ref(null)

const openProductMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('delivery')
    }, OPEN_TIMEOUT)
}

const openProCromiMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('proCromi')
    }, OPEN_TIMEOUT)
}

const closeMenu = () => {
    if (openTimer.value) clearTimeout(openTimer.value)

    closeTimer.value = setTimeout(() => {
        openMenu.value = null
    }, CLOSE_TIMEOUT)
}

function openMenuHandler(menu: 'delivery' | 'proCromi') {
    if (closeMenuTimeout.value) {
        clearTimeout(closeMenuTimeout.value)
        closeMenuTimeout.value = null
    }

    openMenu.value = menu
}

function closeMenuImmediately(): void {
    queueMicrotask(() => {
        closeMenu()
    })
}

onBeforeUnmount(() => {
    if (openTimer.value) clearTimeout(openTimer.value)
    if (closeTimer.value) clearTimeout(closeTimer.value)
})

// useSchemaOrg([
//     defineItemList({
//         name: 'Основная навигация',
//         itemListElement: proCromiList.map((item) => {
//             return defineListItem({
//                 '@type': 'SiteNavigationElement',
//                 name: item.title,
//                 url: item.link.endsWith('/') ? item.link : item.link + '/',
//             })
//         }),
//     }),
// ])
</script>
